import {
  CompanySearchRequest,
  CompanySearchResultEntry,
  SearchSummaryResponse,
} from '../../generated/model/models';
import { SearchConsolidationStats } from '../../generated/model/searchConsolidationStats';
import { SearchConsolidationStatsRequest } from '../../generated/model/searchConsolidationStatsRequest';
import { httpClient } from '../config/httpClient';
import { makeUrl } from '../utils/routes.utils';

export type RequestParams = {
  page?: number;
  size?: number;
  sort?: string[];
  filter?: string[];
};

interface ActivityKeywordsResponse {
  nodes: { key: string; count: number }[];
}

const path = {
  search: '/company/search?recaptchaToken={recaptchaToken}',
  searchSingle: '/company/search/single/{id}?recaptchaToken={recaptchaToken}',
  companySearchSummary: 'company/search/summary',
  getActivityKeywords: '/company/search/treemap',
  consolidationStats: '/company/search/consolidation',
};

export const companySearch = (
  filters: CompanySearchRequest,
  recaptchaToken: string,
  params?: RequestParams,
) => {
  return httpClient.post<CompanySearchRequest>(makeUrl(path.search, { recaptchaToken }), filters, {
    params,
  });
};

export const companySearchSingle = (id: string, recaptchaToken: string) => {
  return httpClient.get<CompanySearchResultEntry>(
    makeUrl(path.searchSingle, { id, recaptchaToken }),
  );
};

export const searchSummary = async (req: CompanySearchRequest): Promise<SearchSummaryResponse> => {
  const resp = await httpClient.post<SearchSummaryResponse>(path.companySearchSummary, req);
  return resp.data;
};

export const getActivityKeywords = (filters: CompanySearchRequest, params?: RequestParams) => {
  return httpClient.post<ActivityKeywordsResponse>(path.getActivityKeywords, filters, { params });
};

export const consolidationStats = async (
  req: SearchConsolidationStatsRequest,
): Promise<SearchConsolidationStats> => {
  const response = await httpClient.post<SearchConsolidationStats>(path.consolidationStats, req);
  return response.data;
};
